<template>
  <div class="building-side">
    <v-btn x-small plain elevation="0" v-if="!!selectedFloorbox.uuid" class="group-button" @click.stop="$emit('click')">
      <v-icon style="font-size: 24px">mdi-select-group</v-icon>
    </v-btn>
    <div v-if="isBuildingEntranceFloor && !selectedFloorbox.uuid" class="door" />
  </div>
</template>

<script>
export default {
  name: "Side",

  props: {
    isBuildingEntranceFloor: {
      type: Boolean,
      default: false
    },

    selectedFloorbox: {
      type: Object
    }
  }
}
</script>

<style>
.building-side {
  width: 35px;
  height: 38px;
  background-color: #a8a8a8;
  margin-left: 4px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.door {
  width: 13px;
  height: 31px;
  background-color: #8a8a8a;
  margin: 7px 0 0 -10px;
}

.group-button {
  margin: 0 0 0 1px;
  width: 18px;
  height: 18px;
  min-width: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/BuildingComponents/Side.vue